import { render } from "./AccountGroupOutline.vue?vue&type=template&id=6ffd195e"
import script from "./AccountGroupOutline.vue?vue&type=script&lang=js"
export * from "./AccountGroupOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__